import View from "./general-info.view";
import Presenter from "./general-info.presenter";
import { ConnectComponent2 } from "util";

export default ConnectComponent2(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/index.js